import { render } from "./CadastrarProfissional.vue?vue&type=template&id=769e6402&scoped=true"
import script from "./CadastrarProfissional.vue?vue&type=script&lang=js"
export * from "./CadastrarProfissional.vue?vue&type=script&lang=js"

import "./CadastrarProfissional.vue?vue&type=style&index=0&id=769e6402&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769e6402"]])

export default __exports__